"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'profession.list.title': 'Professioni',
    'profession.list.empty': 'Nessuna professione trovata',
};
